














































































import { Component, Vue } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import LocationDepartmentsMasterDetails from '@/components/Locations/LocationDepartmentsMasterDetails.vue'
import JourneyTemplatesMasterDetails from '@/components/JourneyTemplates/JourneyTemplatesMasterDetails.vue'
import LocationDetails from '@/components/Locations/LocationDetails.vue';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import Documents from '@/components/Documents/Documents.vue';
import LocationContactsList from '@/components/Locations/LocationContactsList.vue';
import LocationWorkersList from '@/components/Locations/LocationWorkersList.vue';
import ActivityTimeline from '@/components/Activities/ActivityTimeline.vue';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';

@Component({
  name: 'Location',
  components: { LocationDetails, LocationContactsList, LocationWorkersList, JourneyTemplatesMasterDetails, LocationDepartmentsMasterDetails, Notes, Documents, Alert, ActivityTimeline, TaskGrid }
})
export default class extends GiganautVue {

  entityType = EntityType.Location;
  activityEntityType = ActivityEntityType.Location;

  async created() {
    
  } 

  get currentLocation() {
    return LocationDetailsModule.currentLocation;
  }

  get loading() {
    return LocationDetailsModule.loading;
  }

  async navigateToLocationList() {
    this.$router.push({ name: PageNames.AgencyLocations});
    
  }
}
